import {
  ViewLodging,
  TripLodging,
  AccommodationListing,
} from "@/types/accommodation";
import { DateTime } from "luxon";
import logger from "@/utils/logger";

export const convertHomeStayIntoViewLodging = (
  homeStay: AccommodationListing
): ViewLodging => {
  return {
    id: Number(homeStay.listingid),
    name: homeStay.listing_name,
    type: "home",
    description: homeStay.description,
    latitude: Number(homeStay.latitude),
    longitude: Number(homeStay.longitude),
    mainImageURL: homeStay.image_01,
  };
};

const combineDateAndTime = (
  date: string,
  timeString: string,
  timezone: string
): string => {
  logger.log(
    `Combining date: ${date} and time: ${timeString} in timezone: ${timezone}`
  );

  const timeParts = DateTime.fromFormat(timeString, "HH:mm").toFormat("HH:mm");
  logger.log(`Parsed time:`, timeParts);

  const dt = DateTime.fromFormat(
    `${date.split("T")[0]} ${timeParts}`,
    "yyyy-MM-dd HH:mm",
    { zone: timezone }
  );
  logger.log(`DateTime in specified timezone:`, dt.toString());

  const result = dt.toUTC().toISO();
  logger.log(`Resulting UTC ISO string:`, result);

  return result || "";
};

export const convertHomeStayIntoTripLodging = (
  homeStay: AccommodationListing,
  checkIn: string,
  checkOut: string,
  timezone: string,
  numNights: number
): TripLodging => {
  return {
    id: parseInt(homeStay.listingid),
    name: homeStay.listing_name,
    type: "home",
    description: homeStay.description,
    policies: {
      checkIn: combineDateAndTime(checkIn, "14:00", timezone),
      checkOut: combineDateAndTime(checkOut, "12:00", timezone),
    },
    duration: numNights,
    pricing: {
      amount: homeStay.price,
      total: homeStay.price * numNights,
      currency: homeStay.currency,
    },
    coordinates: {
      latitude: parseFloat(homeStay.latitude),
      longitude: parseFloat(homeStay.longitude),
    },
    mainImageURL: homeStay.image_01,
    address: `${homeStay.location}, ${homeStay.state}, ${homeStay.country}`,
    start_time: checkIn,
    bookingStatus: "pending",
    moreInfo: {
      propertyType: homeStay.property_type,
      neighborhood: homeStay.neighbourhood,
    },
  };
};
